import React, { useState } from 'react'

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
} from '@material-ui/core'
import { Button, Input, Typography } from 'sputnik-ui'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { confirmPhoneNumber } from 'store/partners/operations'
import { useDispatch } from 'react-redux'
import { unwrapResult } from '@reduxjs/toolkit'

const StyledAction = styled(DialogActions)`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 24px 20px 24px 20px;
    > * {
      margin: 0;
    }
  }
`
const StyledContent = styled(DialogContent)`
  && {
    padding: 1rem 70px;
    padding-top: 0px;
    overflow: auto;
    @media screen and (max-width: ${(p) => p.theme.sizes.phone}) {
      height: 70vh;
      padding: 0 2rem;
    }
  }
`

const StyledInput = styled(Input)`
  @media screen and (max-width: ${(p) => p.theme.sizes.phone}) {
    &&& {
      color: #fff;
      background: inherit;
      p {
        color: #fff;
      }
    }
  }
`

const StyledDialog = styled(Dialog)`
  && {
    .MuiDialog-paper {
      padding-top: 2rem;
      width: 700px;
      max-width: 90vw;
      height: auto;

      @media screen and (max-width: ${(p) => p.theme.sizes.phone}) {
        height: 90vh; /* Only apply fixed height on mobile */
        overflow-y: auto; /* Enable scrolling only on mobile */
      }
    }
  }
`

export default function ConfirmPhoneModal({
  phone,
  open,
  handleClose,
  Transition,
  onConfirm,
  ...props
}) {
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const handlePassword = (value) => {
    if (value.length > 4) {
      setPassword(value.slice(0, 4))
    } else {
      setPassword(value)
    }
  }

  const { t } = useTranslation(['common', 'profile'])
  const dispatch = useDispatch()

  const handleConfirm = () => {
    dispatch(confirmPhoneNumber({ phone, password }))
      .then(unwrapResult)
      .then((payload) => {
        if (payload.success) {
          handleClose()
          onConfirm(true)
        }
      })
      .catch((error) => {
        setError(error)
      })
  }
  return (
    <StyledDialog
      open={open}
      TransitionComponent={Transition}
      onClose={handleClose}
    >
      <DialogTitle>{t('profile:form.phone.enter_code')}</DialogTitle>
      <StyledContent>
        <DialogContentText>
          {t('profile:form.phone.otp_code_sent')} {phone}
        </DialogContentText>
        <StyledInput
          value={password}
          autoFocus
          onChange={(e) => handlePassword(e.target.value)}
          max="9999"
          label={t('profile:form.phone.otp_code_desc')}
          type="number"
          style={{ width: '100%', maxWidth: '100%' }}
        />
        <Typography
          style={{
            marginTop: '0.5rem',
            fontWeight: '600',
            fontFamily: 'Open Sans',
            fontSize: '12px',
            color: '#FF0E0E',
          }}
        >
          {error}
        </Typography>
        <StyledAction>
          <Button
            rounded
            primary
            variant="v2"
            fullWidth
            onClick={handleConfirm}
          >
            {t('common:button.confirm_capital')}
          </Button>
          <Button onClick={handleClose} tertiary>
            {t('common:button.later')}
          </Button>
        </StyledAction>
      </StyledContent>
    </StyledDialog>
  )
}
